import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
      marginLeft: theme.spacing(30),
      marginTop: theme.spacing(8),
    },
    table: {
      minWidth: 650,
    },
    helpIcon: {
      alignSelf: "center",
      marginLeft: 10,
    },
    marginTop2: {
      marginTop: theme.spacing(2),
      width: "60%",
    },
    marginTopNegative: {
      marginTop: -theme.spacing(2),
    },
    form: {
      marginTop: theme.spacing(2),
      justifyContent: "center",
    },
    paper: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      padding: theme.spacing(2),
      width: "60%",
      [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        padding: theme.spacing(3),
      },
    },
  })
);

export default useStyles;
